/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react'
import {Card, Button} from "@scuf/common";
import {injectIntl} from "react-intl";


class ExpandableCard extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            expanded: this.props.expanded || false,
        }
    }

    render() {
        const collapsedClass = this.state.expanded ? '' : 'collapsed';
        const inTitleSection = this.props.inTitleSection != null ? this.props.inTitleSection : null

        const {intl, expandable, title, content, expandedContent, className, ...cleanedProps} = this.props
        return (
            <Card
                className={(className || '') + ' ' + (expandable ? ('expandable ' + (collapsedClass)) : '')} {...cleanedProps}>
                {title ?
                    <Card.Header title={title}>
                        {inTitleSection}
                    </Card.Header>
                    :
                    null
                }
                <Card.Content>
                    {content}
                    {this.state.expanded ?
                        expandedContent
                        :
                        null
                    }
                </Card.Content>
                {
                    expandable ?
                        <Card.Footer className="expand-footer">
                            <Button type="link"
                                    onClick={() => this.setState({expanded: !this.state.expanded})}>{intl.formatMessage({id: this.state.expanded ? "card.less" : "card.more"})}</Button>
                        </Card.Footer>
                        :
                        ''
                }
            </Card>
        )
    }
}


export default injectIntl(ExpandableCard)